module.exports = __webpack_public_path__ + "static/media/scan-product-canteen.f56b20cf.png";